
import API from './api';

let instance = null;
const api = new API();
const URL_ORG_AGENCIES = '/api/agencies/self';

export default class AgenciesService {

    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    getOrgAgencies() {
        return new Promise((resolve, reject) => {
            api.getJson(URL_ORG_AGENCIES, {
                method: 'GET',
                credentials: 'include',
            })
                .then(response => {
                    if (response.status !== 0) {
                        return reject(response.value);
                    }
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }
}